import { qltClient } from '../clients';
import type { Id, QltTeachingPlanForClassNote } from '../types';

export interface TeachingPlanForClassNoteParams {
  class: Id;
  grade: Id;
  teacher: Id;
  subject: Id;
  status?: 'official' | 'approved' | 'draft';
}

export const TeachingPlanRepository = {
  getForClassNote: (params: TeachingPlanForClassNoteParams) =>
    qltClient
      .get('/getTeachingPlanForClassNote', { params })
      .then((res) => res.data as QltTeachingPlanForClassNote[]),
};

export default TeachingPlanRepository;
